import { transformSchemaOrg } from './schemaOrgTransformer';
import { transformOpenGraph } from './openGraphTransformer';
import { transformTwitterCard } from './twitterCardTransformer';
import { transformMicroformats } from './microformatsTransformer';

export { transformSchemaOrg } from './schemaOrgTransformer';
export { transformOpenGraph } from './openGraphTransformer';
export { transformTwitterCard } from './twitterCardTransformer';
export { transformMicroformats } from './microformatsTransformer';

/**
 * Transforms the Structured Data section data from WooRank API response
 * @param {Object} apiData - The full API response data
 * @returns {Object} - Transformed structured data section data for React components
 */
export const transformStructuredDataSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const schemaOrg = transformSchemaOrg(criteria?.schema_org);
  const openGraph = transformOpenGraph(criteria?.open_graph);
  const twitterCard = transformTwitterCard(criteria?.twitter_card);
  const microformats = transformMicroformats(criteria?.microformats);

  const allResults = [schemaOrg, openGraph, twitterCard, microformats];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    schemaOrg,
    openGraph,
    twitterCard,
    microformats,
  };
};

export default transformStructuredDataSection;

